import axios from 'axios'
import { getCookieValue } from '../common-services'
import { BASE_URL } from './../../config'

export const getStaffsToSelectDriver = async (route_id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?get_all_staff_list=1&schoolCode=${schoolCode}&loginId=${loginId}&route_id=${route_id}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all stop', err.message) // Handle errors
  }
}
export const getStops = async (route_id) => {
  const schoolId = getCookieValue('schoolId')
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getStoppages=1&schoolCode=${schoolCode}&loginId=${loginId}&route_id=${route_id}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all stop', err.message) // Handle errors
  }
}
export const getVehicles = async (route_id) => {
  const schoolId = getCookieValue('schoolId')
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getVehiclesByRoute=1&schoolCode=${schoolCode}&loginId=${loginId}&routeId=${route_id}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all vehicles', err.message) // Handle errors
  }
}
export const getRoutes = async () => {
  const schoolId = getCookieValue('schoolId')
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?get_routes=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all routes', err.message) // Handle errors
  }
}

export const getFeeCLustersByFeeType = async (fee_type) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //
  try {
    return await axios.get(
      `${BASE_URL}/FeeControlNew_1.php?get_all_clusters_new=1&fee_type=${fee_type}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all clusters', err.message) // Handle errors
  }
}
export const addTransportCluster = async (clusterName, clusterSchoolName, studentType) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?transportClusterSender=1&clusterName=${clusterName}&clusterSchoolName=${clusterSchoolName}&studentType=${studentType}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding clusters', err.message) // Handle errors
  }
}
export const deleteTransportCluster = async (FG_Id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?deleteClusterGroup=1&clusterId=${FG_Id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding clusters', err.message) // Handle errors
  }
}
export const getExistingFee = async (session, FG_Id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?countExistingFeeStrucutre=1&FG_Id=${FG_Id}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while checking existing fees', err.message) // Handle errors
  }
}
export const getClusterDetails = async (clusterName, session, structureType) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getClustDetails=1&clusterName=${clusterName}&session=${session}&structureType=${structureType}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while checking existing fees', err.message) // Handle errors
  }
}
export const getClusterDetailsToEdit = async (feeGroupId, session, structureType) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getClusterFeeDetailstoEdit=1&feeGroupId=${feeGroupId}&session=${session}&structureType=${structureType}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting cluster details', err.message) // Handle errors
  }
}
export const getAllMonthsInOrder = async (session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getAllMonthsAsDefined=1&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting all momths', err.message) // Handle errors
  }
}
export const getClustersBySession = async (session, group_type) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?get_all_clusters_by_session=1&group_type=${group_type}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting all clusters', err.message) // Handle errors
  }
}

export const postFeeStructure = async (session, fsmId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?transportPosting=1&session=${session}&fsmId=${fsmId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while posting fee structure', err.message) // Handle errors
  }
}
export const getStudentWiseFeeDetails = async (session, studentId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getIndividualTransportFee=1&session=${session}&studentId=${studentId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting individual fee', err.message) // Handle errors
  }
}
export const getStudentWiseFeeEditForm = async (session, studentId, structureType) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getConcessForm=1&session=${session}&studentId=${studentId}&structureType=${structureType}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting individual fee', err.message) // Handle errors
  }
}
export const updateIndividualStudentFee = async (fdId, concessionAmount) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?updateIndividualTransportFee=1&fdId=${fdId}&concessionAmount=${concessionAmount}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting individual fee', err.message) // Handle errors
  }
}
export const createTransportFeeStructure = async (params) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?createTransferFeeStrucutre=1&${params}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while create new fee structure', err.message) // Handle errors
  }
}
export const editTransportFeeStructure = async (session, feeGroupId, instId, amount, headId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?editFeeStructure=1&session=${session}&feeGroupId=${feeGroupId}&installmentId=${instId}&feeHeadId=${headId}&amount=${amount}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while edit fee structure', err.message) // Handle errors
  }
}
export const postTransportFeeStructure = async (session, fsmId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?transportPosting=1&session=${session}&fsmId=${fsmId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while posting new fee structure', err.message) // Handle errors
  }
}
export const reapplyTransPortFee = async (fromSession, toSession, classId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?transportReApplyFromSessionToSession=1&fromSession=${fromSession}&toSession=${toSession}&classId=${classId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while reapplying transport fee', err.message) // Handle errors
  }
}
export const allotTransportToStudent = async (params) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?assignTransportToStudent=1&${params}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while alloting transport', err.message) // Handle errors
  }
}
export const getStudentPreviousStopages = async (
  clusterName,
  structureType,
  session,
  student_id,
  sec_id,
  class_id,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      // `${BASE_URL}/api-controller/transport/getTransportData.php?getStudentStoppage=1&studentId=${student_id}&clusterName=${clusterName}&session=${session}&structureType=${structureType}&schoolCode=${schoolCode}&loginId=${loginId}`

      `${BASE_URL}/TransportEditStudentStoppage1.php?fetch_prev_stoppage=1&class_id=${class_id}&sec_id=${sec_id}&session=${session}&student_id=${student_id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getiing student previous stopage', err.message) // Handle errors
  }
}
export const getStudentFeeGroupDetails = async (
  student_id,
  clusterName,
  session,
  structureType,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getStudentFeeGroupDetails=1&studentId=${student_id}&clusterName=${clusterName}&session=${session}&structureType=${structureType}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getiing Student Fee Group Details', err.message) // Handle errors
  }
}
export const editStudentStoppageData = async (
  student_id,
  studentType,
  feeGroupType,
  feeGroupId,
  session,
  classId,
  secId,
  installmentMonthsArray,
  uncheckedInstallmentMonthArray,
  stoppageId,
  vehicleId,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?studentId=${student_id}&studentType=${studentType}&feeGroupType=${feeGroupType}&feeGroupId=${feeGroupId}&session=${session}&classId=${classId}&secId=${secId}&installmentMonthsArray=${installmentMonthsArray}&uncheckedInstallmentMonthArray=${uncheckedInstallmentMonthArray}&pickupType=Both&editStudentStoppage=1&stoppageId=${stoppageId}&vehicleId=${vehicleId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while editing student stoppage', err.message) // Handle errors
  }
}
export const addNewRoute = async (routeName, routeDescription) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?addRoute=1&routeName=${routeName}&routeDescription=${routeDescription}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding new route', err.message) // Handle errors
  }
}
export const getAllRoutes = async (routeName, routeDescription) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getRoutes=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all route', err.message) // Handle errors
  }
}
export const updateRoute = async (routeName, routeDescription, routeId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?updateRoute=1&routeName=${routeName}&routeDescription=${routeDescription}&routeId=${routeId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating route', err.message) // Handle errors
  }
}
export const addNewStoppage = async (params) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?addorUpdateTransportStoppage=1&actionType=addStoppage&${params}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding stopage', err.message) // Handle errors
  }
}
export const updateStoppage = async (params) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?addorUpdateTransportStoppage=1&actionType=updateStoppage&${params}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating stopage', err.message) // Handle errors
  }
}
export const deleteStoppage = async (stoppageId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?deleteStoppage=1&stoppageId=${stoppageId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while deleting stopage', err.message) // Handle errors
  }
}
export const getStoppageList = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getStoppages=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all stoppages', err.message) // Handle errors
  }
}

export const getAllVehicles = async () => {
  // getVehicles
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getVehicles=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all vehicled', err.message) // Handle errors
  }
}
export const addNewVehicle = async (params) => {
  // addorUpdateVehicle=1&actionType=addVehicle
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?addorUpdateVehicle=1&actionType=addVehicle&${params}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while saving vehicle', err.message) // Handle errors
  }
}
export const updateExistingVehicle = async (params) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?addorUpdateVehicle=1&actionType=updateVehicle&${params}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating vehicle', err.message) // Handle errors
  }
}
export const deleteVehicle = async (vehicleId) => {
  // deleteVehicle=1&vehicleId=13

  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?deleteVehicle=1&vehicleId=${vehicleId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while deleting vehicle', err.message) // Handle errors
  }
}

export const getAllVehiclesDocs = async () => {
  // getVehicles
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getVehicleDocuments=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all vehicle docs', err.message) // Handle errors
  }
}
export const addVehicleDoc = async (formData) => {
  // getVehicles
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/transport/getTransportData.php?`,formData
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while deleteing vehicle docs', err.message) // Handle errors
  }
}
export const deleteVehiclesDocs = async (DocumentId) => {
  // getVehicles
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?deleteDocument=1&DocumentId=${DocumentId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while deleteing vehicle docs', err.message) // Handle errors
  }
}

export const getDrivers = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getDrivers=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting drivers', err.message) // Handle errors
  }
}
export const addDrivers = async (staffName, licenseNo, remarks) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?addorUpdateDriver=1&actionType=addDriver&staffName=${staffName}&licenseNo=${licenseNo}&remarks=${remarks}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting drivers', err.message) // Handle errors
  }
}
export const updateDrivers = async (driverId, staffName, licenseNo, remarks) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?addorUpdateDriver=1&actionType=updateDriver&driverId=${driverId}&staffName=${staffName}&licenseNo=${licenseNo}&remarks=${remarks}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating drivers', err.message) // Handle errors
  }
}
export const deleteDrivers = async (driverId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?deleteDriver=1&driverId=${driverId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while deleting drivers', err.message) // Handle errors
  }
}
export const getDriversMappedVehicle = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?getmapVehicleDrivers=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getmapVehicleDrivers', err.message) // Handle errors
  }
}
export const addDriversMappedVehicle = async (vehicleNo, driverName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?mapVehicle=1&actionType=addMapDriver&vehicleNo=${vehicleNo}&driverName=${driverName}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while mapVehicle', err.message) // Handle errors
  }
}
export const updateDriversMappedVehicle = async (vehicleNo, driverName, driverId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?mapVehicle=1&actionType=updateMapDriver&vehicleNo=${vehicleNo}&driverName=${driverName}&driverId=${driverId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updateDriversMappedVehicle', err.message) // Handle errors
  }
}
export const deleteDriversMappedVehicle = async (driverId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?deleteMapDriver=1&driverId=${driverId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while deleteDriversMappedVehicle', err.message) // Handle errors
  }
}

export const getBusPassConfig = async (session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/GetConfiguration.php?session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting bus pass config', err.message) // Handle errors
  }
}
export const updateBusConfig = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', getCookieValue('schoolCode'))
    formdata.append('loginId', getCookieValue('loginId'))
  try {
    return await axios.post(`${BASE_URL}/BusPassConfiguration1.php&`, formdata) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating bus pass config', err.message) // Handle errors
  }
}

export const getStudentsBusPass = async (classId, secId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?&schoolCode=${schoolCode}&loginId=${loginId}&getStudentsForBusPass=1&classId=${classId}&secId=${secId}&session=${session}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updateDriversMappedVehicle', err.message) // Handle errors
  }
}

export const getAllotedTransport = async (classId, secId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/transport/getTransportData.php?&schoolCode=${schoolCode}&loginId=${loginId}&getStudentsAllotted=1&classId=${classId}&secId=${secId}&session=${session}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updateDriversMappedVehicle', err.message) // Handle errors
  }
}

export const vehicleDues = async (session, VehicleId, duedate, dueamount, schoolFee) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/TransportReportVehicleWise1.php?Session=${session}&VehicleId=${VehicleId}&duedate=${duedate}&dueamount=${dueamount}&include_school_fee=${schoolFee}&GetVehicleStudent=GetVehicleStudent&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updateDriversMappedVehicle', err.message) // Handle errors
  }
}

export const getServiceProvider = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/GpsDetailsController.php?getdata=get_service_provider&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updateDriversMappedVehicle', err.message) // Handle errors
  }
}

export const AllocateGPSDevice = async (vehicleId, ServiceProvider, deviceId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/GpsDetailsController.php?allocate_gps_device=0&vehicle_id=${vehicleId}&service_provider=${ServiceProvider}&device_id=${deviceId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updateDriversMappedVehicle', err.message) // Handle errors
  }
}

export const AddGPSDeviceDetails = async (
  serviceProviderName,
  userName,
  password,
  clientId,
  userId,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const formData = new FormData()
  formData.append('submit_gps_details', '0')
  formData.append('sevice_provider_name', serviceProviderName)
  formData.append('user_name', userName)
  formData.append('password', password)
  formData.append('client_id', clientId)
  formData.append('user_id', userId)
  formData.append('school_code', schoolCode)
  formData.append('login_id', loginId)

  try {
    return await axios.post(`${BASE_URL}/GpsDetailsController.php`, formData)
  } catch (err) {
    console.log('Error while submitting GPS device details:', err.message)
  }
}

export const allocateRfidCard = async (formData) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formData.append('school_code', schoolCode)
  formData.append('login_id', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/TransportRFIDController.php`,formData
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updateDriversMappedVehicle', err.message) // Handle errors
  }
}

export const CardTrapping = async (formData) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formData.append('school_code', schoolCode)
  formData.append('login_id', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/TransportRFIDController.php`,formData
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updateDriversMappedVehicle', err.message) // Handle errors
  }
}

export const getallVehiclesTrackedItem = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/GpsDetailsController.php?getdata=get_tracked_item&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting vehicle dropdown', err.message) // Handle errors
  }
}

export const getAuth = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/gpslocationapi.php?set_authentication=set_authentication&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting token', err.message) // Handle errors
  }
}

export const getLatLong = async (trackedItemId, tokenKey) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    const url = `${BASE_URL}/gpslocationapi.php?get_lat_long=get_lat_long&tracked_item_id=5582&schoolCode=${encodeURIComponent(schoolCode)}&loginId=${encodeURIComponent(loginId)}`

    const headers = tokenKey
      ? { Authorization: `Bearer ${tokenKey}` }
      : {}

    const response = await axios.get(url, { headers })
    return response.data
  } catch (err) {
    console.error('❌ Error while getting Lat/Long:', err.message)
    throw err
  }
}